import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/mediacenter-banner.jpg")